import { News } from './types';
import Button from '../Button';
import RelDefaultImg from '@/assets/img/img_default.jpg';
import { Category, KeysSet, RemoveHtml } from '@/components/News/WordSet';
import { H2_3 } from '@/components/Titles';
import { breakpoint } from '@/helpers/BreakpointHelper';
import { Link } from 'gatsby';
import React, { FC } from 'react';
import styled from 'styled-components';

export const BannerCard = styled.div`
  display: flex;
  flex-wrap: wrap;
  position: relative;

  .cate {
    background: #1cabe2;
    color: #fff;
    font-size: 16px;
    width: 103px;
    line-height: 40px;
    font-weight: 700;
    text-align: center;
    position: absolute;
    left: 0;
    bottom: -20px;
    z-index: 1;
  }

  .col-img {
    width: 100%;
    position: relative;

    .img-box {
      padding-top: 100%;
    }
  }

  .col-dec {
    width: 100%;
    padding-top: 32px;

    .two-line {
      height: 58px;
      max-height: 58px;

      ${breakpoint(`mobile`)} {
        height: 48px;
        max-height: 48px;
      }
    }

    .dec {
      display: none;
    }

    .tag-wrap {
      margin-top: 12px;
      ${Button} {
        height: 26px;
        line-height: 24px;
        font-size: 14px;
        padding: 0 5px;
        margin-right: 8px;
        margin-bottom: 8px;
        font-weight: normal;
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  &.big {
    flex-wrap: nowrap;
    align-items: stretch;
    flex-direction: row-reverse;
    background: #f8f9fa;

    .cate {
      font-size: 20px;
      width: 128px;
      line-height: 48px;
      top: 24px;
      bottom: auto;
    }

    .col-img {
      width: 39%;
      position: initial;

      .img-box {
        height: 100%;
      }
    }
    ${H2_3} {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      white-space: normal;
      overflow: hidden;
      line-height: normal;
    }
    .col-dec {
      width: 61%;
      padding-top: 104px;
      padding-left: 52px;
      padding-right: 108px;

      ${breakpoint(1120)} {
        padding-left: 4.63vw;
        padding-right: 9.64vw;
      }

      .dec {
        display: block;
        margin-top: 24px;
        white-space: normal;
        overflow: hidden;
        font-size: 16px;
        line-height: normal;
        &::after {
          content: '...';
          display: inline-block;
          vertical-align: bottom;
        }
      }

      .tag-wrap {
        margin-top: 16px;
      }

      .date {
        display: none;
      }
    }
  }
`;

interface NewsBannerProps {
  banner: News;
  basePath: string;
}

const NewsBannerItem: FC<NewsBannerProps> = ({ basePath, banner }) => {
  let image = banner.imgAttGrpNoTn;
  if (image === undefined || image.indexOf(`null`) !== -1) {
    image = RelDefaultImg;
  }
  return (
    <>
      <Link
        to={`${basePath}/${banner.boardIndexNumber}`}
        className="link-item"
        state={{ boardCategoryCode: banner.boardCategoryCode }}
      >
        <BannerCard className="big">
          <div className="col-img">
            <div
              className="img-box"
              css={`
                background-image: url(${image});
              `}
            />
            <div className="cate">
              {Category(`${banner.boardCategoryCode}`)}
            </div>
          </div>
          <div className="col-dec">
            <H2_3>{banner.subject} </H2_3>
            <p className="dec">
              {/* {RemoveHtml(`${banner.contents.substr(0, 415)}`)} */}
              {RemoveHtml(`${banner.contents.substr(0, 2000)}`).substring(
                0,
                415,
              )}
            </p>
            <div className="tag-wrap">
              {banner.relCategoryCode !== null &&
                KeysSet(`${banner.relCategoryCode}`).map((key) => (
                  <Button outline key={key.tag} className="tag">
                    <Link
                      to={`/what-we-do/news?category=${key.tag}#newsSection`}
                      key={key.tag}
                    >
                      #{key.tagName}
                    </Link>
                  </Button>
                ))}
            </div>
          </div>
        </BannerCard>
      </Link>
    </>
  );
};
export default NewsBannerItem;
